import { NavLink, Link } from "react-router-dom";

import css from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={css.footer}>
      <div className={`${css["container-footer"]} container`}>
        <div className={`${css["footer-div"]} ${css["footer-left"]}`}>
          <Link to="/">
            <img
              src="/img/SOLVIXCODE logo-light 1.png"
              alt="solvixcode-logo-light"
              className="logo-img"
            />
          </Link>
          <ul className={css["footer-links"]}>
            <li>
              <a
                href="https://github.com/Olha-Fursova"
                className={css["icon-link"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg className={`icon ${css["icon-footer"]}`}>
                  <use href="/img/icons.svg#icon-github"></use>
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/olha-fursova-6727b7265/"
                className={css["icon-link"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg className={`icon ${css["icon-footer"]}`}>
                  <use href="/img/icons.svg#icon-linkedin"></use>
                </svg>
              </a>
            </li>
          </ul>
        </div>

        <div className={css["footer-div"]}>
          <h3 className={`small-heading ${css["heading-footer"]}`}>
            Website structure
          </h3>
          <ul className={css["footer-structure-list"]}>
            <li className={css["footer-list-item"]}>
              <NavLink to="/" className={`${css["footer-link"]} p-text`}>
                Home
              </NavLink>
            </li>
            <li className={css["footer-list-item"]}>
              <NavLink
                to="/portfolio"
                className={`${css["footer-link"]} p-text`}
              >
                My portfolio
              </NavLink>
            </li>
            {/* <li className={css["footer-list-item"]}>
              <NavLink to="/blog" className={css["footer-link"]}>
                Blog
              </NavLink>
            </li>
            <li className={css["footer-list-item"]}>
              <NavLink to="/contact" className={css["footer-link"]}>
                Contact
              </NavLink>
            </li> */}
          </ul>
        </div>

        <div className={css["footer-div"]}>
          <div className={css["footer-div"]}>
            <h3 className={`small-heading ${css["heading-footer"]}`}>
              To get in touch
            </h3>
            <a
              href="mailto:solvixcode@gmail.com"
              className={`${css["footer-link"]} p-text`}
              target="_blank"
            >
              solvixcode@gmail.com
            </a>
          </div>
          <div className={css["footer-div"]}>
            <h3 className={`small-heading ${css["heading-footer"]}`}>
              Remote work from:
            </h3>
            <p className={`${css["footer-text"]} p-text`}>
              Groningen, Netherlands
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
